import { render, staticRenderFns } from "./DosimetrieItemEdp.vue?vue&type=template&id=74ddb4bc&"
import script from "./DosimetrieItemEdp.vue?vue&type=script&lang=js&"
export * from "./DosimetrieItemEdp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports